import { useForm } from "react-hook-form";
import { Stack, Typography, useTheme } from "@mui/material";
import dayjs from "dayjs";

import { Strings } from "@app/constants";

const Year = ({ methods }: any) => {
  const last15year = Array.from({ length: 15 }, (_, index) =>
    (dayjs().year() - index).toString(),
  );
  const theme = useTheme();
  const year = methods.watch("year");

  return (
    <>
      <Stack flexDirection={"column"} py={2}>
        <Stack
          sx={{
            alignItems: "center",
            justifyContent: "center",
            gap: 1,
          }}
        >
          <Typography
            sx={{
              fontSize: 24,
              fontWeight: "bold",
            }}
          >
            {Strings.step.year.manufacturingYear}
          </Typography>
          <Typography variant="body1" sx={{ color: theme.palette.grey[500] }}>
            {Strings.step.year.whenWasYourCarManufactured}
          </Typography>
        </Stack>
      </Stack>
      <Stack sx={{ alignItems: "center", justifyContent: "center" }}>
        <Stack
          sx={{
            mt: { xs: 2, md: 5 },
            width: { xs: "100%", sm: "80%" },
            flexDirection: "row",
            flexWrap: "wrap",
            gap: 2,
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          {last15year.map((item, index) => (
            <Stack
              key={index}
              onClick={() =>
                methods.setValue("year", item, { shouldValidate: true })
              }
              sx={{
                px: { xs: 1.5, md: 3 },
                py: 1.5,
                border: 1,
                borderRadius: 2,
                cursor: "pointer",
                borderColor:
                  year === item
                    ? theme.palette.primary.main
                    : theme.palette.common.black,
                boxShadow: "0 2px 6px rgba(0, 0, 0, 0.1)",
                justifyContent: "center",
                alignItems: "center",
                flexDirection: "column",
                textAlign: "center",
                backgroundColor:
                  year === item ? theme.palette.primary.main : "transparent",
              }}
            >
              <Typography
                variant="subtitle1"
                sx={{
                  fontWeight: 600,
                  color:
                    year === item
                      ? theme.palette.common.white
                      : theme.palette.grey[900],
                }}
              >
                {item}
              </Typography>
            </Stack>
          ))}
        </Stack>
      </Stack>
      {methods.formState.errors?.year && (
        <Typography color="error" textAlign="center" mt={2}>
          {methods.formState.errors.year.message}
        </Typography>
      )}
    </>
  );
};

export { Year };
